import React from 'react';
import T from 'prop-types';
import cx from 'classnames';
import { isEmpty } from 'lodash-es';

import Skeleton from '../../../../components/Skeleton';
import { numberToPercentage } from '../../../../utils/formatter';

const formatCell = (value) => {
  if (value == null) return '\u2014';
  return numberToPercentage(value, { precision: 1 });
};

const TransitionsTable = ({ data, columns, rows, isPending, skeletonHeight = 210 }) => {
  if (isPending) {
    return <Skeleton height={skeletonHeight} className="d-flex" />;
  }

  if (!isPending && isEmpty(data)) {
    return <div className="transitions-table__empty">No data available</div>;
  }

  return (
    <table className="transitions-table">
      <thead>
        <tr>
          <th>
            <div className="th-cell-directions">
              <span>From</span> <span className="hicon-arrow-down" /> <span>|</span> <span>To</span>{' '}
              <span className="hicon-arrow-right" />
            </div>
          </th>
          {columns.map(({ dataField, text, color }) => (
            <th key={dataField} style={{ color }}>
              {text}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((from) => (
          <tr key={from.dataField}>
            <td style={{ color: from.color }}>{from.text}</td>
            {columns.map((to) => (
              <td
                key={to.dataField}
                className={cx({ 'text-bold': from.dataField === to.dataField })}
              >
                {formatCell(data[from.dataField]?.[to.dataField])}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

TransitionsTable.propTypes = {
  data: T.object,
  columns: T.arrayOf(
    T.shape({
      dataField: T.string.isRequired,
      text: T.string.isRequired,
      color: T.string,
    })
  ).isRequired,
  rows: T.arrayOf(
    T.shape({
      dataField: T.string.isRequired,
      text: T.string.isRequired,
      color: T.string,
    })
  ).isRequired,
  skeletonHeight: T.number,
  isPending: T.bool,
};

export default TransitionsTable;
